
import dayjs from 'dayjs';
var relativeTime = require("dayjs/plugin/relativeTime");
var utc = require("dayjs/plugin/utc");
var duration = require("dayjs/plugin/duration");
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(duration);

export default dayjs;